var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block-actions",
    },
    [
      _c("studip-action-menu", {
        attrs: {
          items: _vm.menuItems,
          context: _vm.block.attributes.title,
          collapseAt: 1,
        },
        on: {
          editBlock: _vm.editBlock,
          setVisibility: _vm.setVisibility,
          showInfo: _vm.showInfo,
          deleteBlock: _vm.deleteBlock,
          removeLock: _vm.removeLock,
          copyToClipboard: _vm.copyToClipboard,
          deactivateComments: _vm.deactivateComments,
          activateComments: _vm.activateComments,
          showFeedback: _vm.showFeedback,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }